<template>
  <div class="text-center small noselect">
    <span @click="prevWeek()" :class="{disable:!viewPrew}"><span class="icon prev"></span></span> <span
      @click="nextWeek()"><span class="icon next"></span></span>
  </div>
  <div class="text-center small mt-2" v-if="!spinerView">
    <small>Режим работы: с {{ getOfficeWorkTimeStart }} до {{ getOfficeWorkTimeEnd }}</small>
  </div>
  <div class="booking-table my-4">
    <span v-if="spinerView" class="spinner-border spinner-border-sm text-primary position-absolute"
          style="top:50%; left: 50%;"></span>
    <template v-if="!spinerView && this.$store.state.vModeWeek == 1 ">
      <div class="syncscroll-wrap">
        <TimeLine v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
        <div class="d-flex">
          <div class="relblock">
            <CabCard
                v-for="(date) in getDates"
                v-bind:key="date"
                v-bind:date="date"
            />
          </div>
          <div class="table-content wrapper-scroll" :class="{ loading: this.$store.state.loading }"

               @mousedown="mousedown"
               @mouseup="mouseup"
               @mouseleave="mouseup"
               @mousemove="mouseMove"
          >
            <BTWallCells
                v-for="(date) in getDates"
                v-bind:key="date"
                v-bind:date="date"
                v-bind:priceData="getPriceData(date)"
                v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
                v-bind:timeZone = "getOfficeTimezone"
            />
          </div>

        </div>
      </div>
    </template>
    <template v-if="!spinerView && this.$store.state.vModeWeek == 0 ">
      <div class="cabcard-wrap">
        <div class="cabcard-empty"></div>
        <CabCard
            v-for="(date) in getDates"
            v-bind:key="date"
            v-bind:date="date"
        />
      </div>

      <div class="d-flex vertical">
        <div class="relblock-time">
          <TimeLine v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
        </div>
        <div class="table-content" :class="{ loading: this.$store.state.loading }">
          <BTWallCells
              v-for="(date) in getDates"
              v-bind:key="date"
              v-bind:date="date"
              v-bind:priceData="getPriceData(date)"
              v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
              v-bind:timeZone = "getOfficeTimezone"
          />
        </div>
      </div>
    </template>
  </div>

</template>

<script>

import TimeLine from "@/components/TimeLine";
import BTWallCells from "@/components/BookingTable/BTWallCells";
import CabCard from "@/components/BookingTable/CabCard";
import {dateFormat} from "@/dateFormat";


export default {
  components: {
    CabCard,
    BTWallCells,
    TimeLine
  },
  props: {
    officeId: Number
  },
  inject: ['searchData'],
  provide() {
    // use function syntax so that we can access `this`
    return {
      viewPrew: false,
      officeId: Number(this.officeId),
      selectData: this.getSelectData,
      mySelectData: this.getMySelectData,
      errorData: this.getErorrData
    }
  },
  name: 'BookingTable',
  data() {
    return {
      // daysTitle:[
      //     'воскресенье',
      //     'понедельник',
      //     'вторник',
      //     'среда',
      //     'четверг',
      //     'пятница',
      //     'суббота'
      // ],
      viewPrew: false,
      spinerView: true,
      // keyposfix: 1
      speed: 1, // Скорость скролла.
      left: 0, //нажали мышку - сохраняем положение скролла
      drag: false,
      coorX: 0 // нажали мышку - сохраняем координаты.
    }
  },
  mounted() {
    this.scrollInit()

  },
  updated(){
    this.scrollInit()
  },
  watch: {

    'searchData.date'(val) {
      let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
      if (dateFormat.compare(val, nowDate) == '>') {
        // console.log(val)
        this.viewPrew = true
      } else {
        // console.log(val)
        this.viewPrew = false
      }

    },
    '$store.state.data': {

      handler() {
        // console.log('WATCH')
        this.spinerView = false;
      },
      deep: true
    }

    // '$store.state.date'(val){
    //   let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
    //   if(dateFormat.compare(val,nowDate) == '>'){
    //     // console.log('ALEX','VIEW')
    //     this.viewPrew = true
    //   }else{
    //     // console.log('ALEX','NOW')
    //     this.viewPrew = false
    //   }
    //
    // }
  },
  computed: {
    getOfficeWorkTimeStart() {
      return this.$store.state.data.cabinet['workTimeStart']
    },
    getOfficeWorkTimeEnd() {
      return this.$store.state.data.cabinet['workTimeEnd']
    },
    getOfficeTimezone() {
      return this.$store.state.data.cabinet['timeZone']
    },
    dateFormat() {
      return dateFormat.strToFormat(this.$store.state.date)
    },
    dateFormatDay() {
      let date = new Date(this.$store.state.date)
      let dayNum = date.getDay()
      return this.daysTitle[dayNum]
    },
    getCalcKey() {
      return this.calcKey;
    },
    getErorrData() {
      return this.$store.state.selector.error
    },
    getSelectData() {
      return this.$store.state.selector.new
    },
    getMySelectData() {
      return this.$store.state.selector.my
    },
    getOfficeTitle() {
      return this.$store.state.office.data[this.officeId]['title']
    },
    getOfficeUrl() {
      return '/places/' + this.$store.state.office.data[this.officeId]['url_alias']
    },
    // getCabinetsTimeRange(){
    //     return this.calcTimeRange()
    // },
    getDates() {
      // return this.$store.state.loading ? ["2023-05-01","2023-05-02","2023-05-03","2023-05-04","2023-05-05","2023-05-06","2023-05-07"] : this.$store.state.data.dates
      return this.$store.state.data.dates
    },
    getCabinetsPrices() {
      // console.log(this.$store.state.cabinet.data.cabinetsPrices[this.officeId])

      return this.$store.state.data.prices
    },
  },
  methods: {
    prevWeek() {
      this.$emitter.emit('prevWeek')
    },
    nextWeek() {
      this.$emitter.emit('nextWeek')
    },
    getPriceData: function (dt) {
      let date = new Date(dt)
      let dayNum = date.getDay()
      let type = dayNum == 0 || dayNum == 6 ? 'weekend' : 'weekdays'
      // console.log(this.$store.state.data.prices[type])
      return this.$store.state.data.prices[type]
    },
    prevDate() {
      this.$emitter.emit('prevDate')
    },
    nextDate() {
      this.$emitter.emit('nextDate')
    },
    mousedown(e) {
      let el = e.currentTarget;
      this.drag = true
      this.coorX = e.pageX - el.offsetLeft;
      this.left = el.scrollLeft;
    },
    mouseup() {
      this.drag = false
    },
    mouseMove(e) {
      if (this.drag) {
        let el = e.currentTarget;
        let scroll = this.left - (e.pageX - el.offsetLeft - this.coorX) * this.speed;

        el.scrollLeft = scroll;
      }
    },
    scrollInit() {
      let mousescroll = document.querySelectorAll('.booking-table .mousescroll');

      for (let elem of mousescroll) {

        elem.addEventListener('scroll', ({currentTarget}) => {

          let parent = elem.closest('.booking-table');
          if (parent) {
            let syncscroll = parent.querySelector('.table-content.wrapper-scroll');
            syncscroll.scrollLeft = currentTarget.scrollLeft
          }
        })
      }

      let syncscroll = document.querySelectorAll('.booking-table .table-content.wrapper-scroll');

      for (let elem of syncscroll) {

        elem.addEventListener('scroll', ({currentTarget}) => {

          let parent = elem.closest('.booking-table');
          if (parent) {
            let syncscroll = parent.querySelector('.mousescroll:first-child');
            syncscroll.scrollLeft = currentTarget.scrollLeft
          }

        })
      }
    }
  }
}
</script>

<style scoped>

.cabcard-wrap{
  display: flex;
  flex-direction: row;
}

.cabcard-empty{
  width: 4rem;
  margin-right: 2px;
}
.vertical .table-content{
  width: 100%;
  display: flex;
}

.noselect {
  user-select: none;
}

.disable {
  opacity: .1;
}

.icon {
  position: relative;
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  background-repeat: no-repeat;
  background-position: bottom;
  position: relative;
  top: 4px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color ease .4s;
}

.icon:hover {
  background: #ffdec0;
}

.icon.next {

  margin-left: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-right-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z'/%3E%3C/svg%3E");
}

.icon.prev {
  margin-right: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-left-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z'/%3E%3C/svg%3E");
}

.booking-table {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  will-change: transform;
}

/*.cab-info-wrap {*/
/*  min-width: 250px;*/
/*}*/
.wrapper-scroll {
  overflow: hidden;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

}

.wrapper-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.wrapper-scroll .scroll-y {
  display: none !important;
}

/*.table-content {*/
/*  width: calc(100% - 150px);*/
/*}*/

/*.table-content.loading{*/
/*  background: #faf9f9;*/
/*}*/

.relblock {
  width: 150px;
  max-width: 250px;
  position: relative;
  min-height: 448px;
}

/*.relblock.loading{*/
/*  background: #faf9f9;*/
/*}*/

.relblock-wrap {
  background-color: #fff;
  transition: background-color ease .7s;
}

.relblock-wrap.loading {
  background-color: #faf9f9;
}

/*.relblock {*/
/*  opacity: 1;*/
/*  transition: opacity ease .7s;*/
/*}*/

/*.relblock-wrap.loading .relblock {*/
/*  opacity: 0;*/
/*}*/

.textlink {
  color: #444;
  text-decoration: none;
}

@media (max-width: 670px) {
  .relblock {
    max-width: 120px;
  }

  /*.table-content {*/
  /*  width: calc(100% - 120px);*/
  /*}*/
}
</style>